import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { Box } from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import useSetBreadcrumbsForPage from 'src/Libs/navigation/hooks/use-set-breadcrumbs-for-page'
import StorageBatterySettingItem from './components/StorageBatterySettingItem'
import { useInstallationBatterySettings } from './hooks'
import { StorageBatterySettingsSkeleton } from 'src/Routes/SystemSettings/Settings/SystemSettingsSkeletons'

interface Props {
  parentBreadcrumb: Breadcrumb
}

/**
 * Base entry point for Flow storage battery settings.
 *
 * This component is a starting point for the Hager battery voltage page.
 */
export const StorageBatterySettingsPage: React.FC<Props> = ({ parentBreadcrumb }) => {
  useSetBreadcrumbsForPage(parentBreadcrumb, 'framework.battery')
  const { hasInstallationWritingRights: userCanEdit } = useInstallationAccessRightsContext()

  const { installationId } = useParams<{ installationId: string }>()
  const { isLoading, updateSettings, batteries, allHaveErrors } = useInstallationBatterySettings(Number(installationId))

  if (isLoading) return <StorageBatterySettingsSkeleton />

  if (!isLoading && batteries.length < 1) {
    return <SystemSettingsBlankView variant={allHaveErrors ? 'error' : 'no-data'} />
  }

  return (
    <Box>
      {batteries.map(battery => (
        <StorageBatterySettingItem
          key={`${battery.batteryListIndex}-${battery.storageSerialNo}`}
          model={battery}
          onUpdate={updateSettings}
          batteryId={battery.batteryListIndex.toString()}
          isReadOnlyAccess={!userCanEdit}
          isLoading={isLoading}
        />
      ))}
    </Box>
  )
}
